<template>
    <v-container bg fill-height grid-list-md text-xs-center>
      <v-layout row wrap align-center>
          <v-flex>
              <v-card v-if="isConformityVisible">
                  <v-card-title class="justify-center font-weight-bold">Client data</v-card-title>
                      <v-card-text>
                          <esign-get-operation
                              :token="$store.getters.esignToken"
                              :end-point="`${endPoint}${'getoperationbyuuid/'}`"
                              :domain-uuid="$store.getters.domainUuid"
                              :operation-uuid="$store.getters.operationUuid"
                              :status=0
                              response=""
                              :loading=false
                              :snack-bar=false
                              success-msg="Se ha obtenido los datos de la operación"
                              error-msg="Ha ocurrido un error al conseguir los datos de la operación"
                          ></esign-get-operation>
                      </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn class="primary" v-if="isButtonConformityVisible" @click="goToDocuments">Continue</v-btn>
                  </v-card-actions>
              </v-card>
              <v-card v-if="isVisiblePDF">
                  <v-card-title class="justify-center font-weight-bold">Operation documents</v-card-title>
                      <v-card-text>
                          <v-layout row>
                              <v-flex lg6 md6 sm12 xs12 align-center>
                                  <label>Signed document</label>
                              </v-flex>
                              <v-flex lg6 md6 sm12 xs12 align-center>
                                  <label>Operation act</label>
                              </v-flex>
                          </v-layout>
                          <v-layout row>
                              <v-flex lg6 md6 sm12 xs12 align-center>
                                  <esign-view-pdf 
                                      :token="$store.getters.esignToken"
                                      :end-point="`${endPoint}${'getdocumentbyuuidb64/'}`"
                                      :operation-uuid="$store.getters.operationUuid"
                                      :document-uuid="$store.getters.documentUuid"
                                      :width=500
                                      :height=710
                                      :status=0
                                      response=""
                                      :loading=false
                                      :snack-bar=false
                                      success-msg="El documento ha sido descargado"
                                      error-msg="Ha ocurrido un error al descargar el documento"
                                  ></esign-view-pdf>
                              </v-flex>
                              <v-flex lg6 md6 sm12 xs12 align-center>
                                  <esign-view-acta-pdf
                                      :token="$store.getters.esignToken"
                                      :end-point="`${endPoint}${'actabyoperationuuidb64/'}`"
                                      :operation-uuid="$store.getters.operationUuid"
                                      :width=500
                                      :height=710
                                      :status=0
                                      response=""
                                      :loading=false
                                      :snack-bar=false
                                      success-msg="El documento ha sido descargado"
                                      error-msg="Ha ocurrido un error al descargar el documento"
                                  ></esign-view-acta-pdf>
                              </v-flex>
                          </v-layout>
                      </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn class="primary" v-if="isButtonDocumentsVisible" @click="goToHome">Go to home</v-btn>
                  </v-card-actions>
              </v-card>
          </v-flex>
      </v-layout>
      <v-snackbar
        v-model="isSnackBarVisible"
        :top=true
        :color="snackBarColor"
        :right=true
        :timeout=4000>
        {{ snackBarText }}
      </v-snackbar>
    </v-container>
</template>

<script>
import EsignGetOperation from "@/components/signature/GetOperation";
import EsignViewPdf from "@/components/signature/ViewPDF";
import EsignViewActaPdf from "@/components/signature/ViewActaPDF";
export default {
  name: "resumeSignature",
  components: {
    EsignGetOperation,
    EsignViewPdf,
    EsignViewActaPdf
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  mounted() {
    // Google Analytics
    // this.$ga.page(this.$router);
    this.EventBus.$on("successGetOperation", () => {
      this.isConformityVisible = true;
      this.isButtonConformityVisible = true;
    });
    this.EventBus.$on("errorGetOperation", () => {
      this.snackBarColor = "error";
      this.snackBarText =
        "An error occurred getting the operation data. Please refresh the page.";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifyGetOperationF", () => {});
    this.EventBus.$on("successViewPDF", () => {
      this.isButtonDocumentsVisible = true;
    });
    this.EventBus.$on("errorViewPDF", () => {
      this.snackBarColor = "error";
      this.snackBarText =
        "An error occurred while downloading the document. Please refresh the page.";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifyViewPDF", () => {});
    this.EventBus.$on("successViewActaPDF", () => {
      this.isButtonDocumentsVisible = true;
    });
    this.EventBus.$on("errorViewActaPDF", () => {
      this.snackBarColor = "error";
      this.snackBarText =
        "An error occurred while downloading the act. Please refresh the page.";
      this.isSnackBarVisible = true;
    });
    this.EventBus.$on("notifyViewActaPDF", () => {});
  },
  data() {
    return {
      endPoint: process.env.VUE_APP_BASEURL,
      isConformityVisible: true,
      isButtonConformityVisible: false,
      isVisiblePDF: false,
      isVisibleActaPDF: false,
      isButtonDocumentsVisible: true,
      snackBarColor: "",
      snackBarText: "",
      isSnackBarVisible: false
    };
  },
  methods: {
    goToDocuments() {
      this.isConformityVisible = false;
      this.isVisiblePDF = true;
      this.isVisibleActaPDF = true;
    },
    goToHome() {
      this.$router.push({ name: "HomePage" });
    }
  }
};
</script>

<style scoped>
</style>
